export default __webpack_public_path__ + "static/media/marauders-map-v1-02-01.b7387de4.jpg";